module.exports = require("@nextcloud/browser-storage");